import fetch from 'auth/FetchInterceptor'

const SettingsService = {}

// Homepage
SettingsService.getHomepageSettings = function (lang) {
	return fetch({
		url: '/settings/homepage',
		method: 'get',
		params: { lang },
	})
}

SettingsService.setHomepageSettings = function (data) {
	return fetch({
		url: '/settings/homepage',
		method: 'post',
		data: data,
	})
}

// General
SettingsService.getSettings = function (data) {
	return fetch({
		url: '/settings',
		method: 'get',
		params: data,
	})
}

SettingsService.setSettings = function (data) {
	return fetch({
		url: '/settings',
		method: 'post',
		data: data,
	})
}

// Language Change Setting
SettingsService.getLanguageChangeSetting = function () {
	return fetch({
		url: '/settings/language-change',
		method: 'get',
	})
}

SettingsService.setLanguageChangeSetting = function (data) {
	return fetch({
		url: '/settings/language-change',
		method: 'post',
		data: data,
	})
}

export default SettingsService
